import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import PointActivityContent from "modules/PointActivity";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const PointActivityPage: React.FC = () => {
  setTitle("Point Activity");
  return (
    <Auth>
      <Layout>
        <PointActivityContent />
      </Layout>
    </Auth>
  );
};

export default PointActivityPage;
